module.exports = {
    test: {
        domainName: '',
        certificateName: '',
        appClientId: '',
        userPool: '',
        serviceUserPool: '',
        serviceAppClientId: '',
        iamRole: '',
        cloudfrontIamRole: '',
        region: '',
        securityGroupId: '',
        stage: '',
        standardAuthorizer: '',
        serviceBasicAuthorizer: '',
        subnetIdOne: '',
        subnetIdTwo: '',
        subnetV2Id1: '',
        subnetV2Id2: '',
        subnetV2Id3: '',
        packageIndividually: false,
        dbUser: '',
        dbPassword: '',
        snsSendCforceEmailTopic: '',
        brokerAgreementExpressWebhook: 'TEST-brokerAgreementExpressWebhook'
    },
    local: {
        domainName: 'api.nexiopaydev.com',
        certificateName: '*.nexiopaydev.com',
        appClientId: '1fng95dprkgs8hoe8al226v6ae',
        userPool: 'us-east-1_g4jnHb4HE',
        serviceUserPool: 'us-east-1_iU9rqeQmV',
        serviceAppClientId: '6tsakgncqfh5hap93r305hi7t4',
        iamRole: 'arn:aws:iam::720154970215:role/cforce-lambda-services',
        cloudfrontIamRole: 'arn:aws:iam::720154970215:role/cfn-cloudfront-lambda-execution',
        region: 'us-east-1',
        securityGroupId: 'sg-47b26d35',
        stage: 'development',
        standardAuthorizer: 'arn:aws:lambda:us-east-1:720154970215:function:cforce-auth-development-standardAuthorizer',
        serviceBasicAuthorizer: 'arn:aws:lambda:us-east-1:720154970215:function:emvio-auth-development-authorizeService',
        subnetIdOne: 'subnet-5692017a',
        subnetIdTwo: 'subnet-45777479',
        subnetV2Id1: 'subnet-083b1c947265056d2',
        subnetV2Id2: 'subnet-083f3618715ea98de',
        subnetV2Id3: 'subnet-036e909ee8114e910',
        packageIndividually: false,
        dbUser: process.env.DB_USER || '',
        dbPassword: process.env.DB_PASSWORD || '',
        snsSendCforceEmailTopic: 'sendCforceEmailNotification-development',
        brokerAgreementExpressWebhook: 'broker-agreement-express-webhook-development'
    },
    development: {
        domainName: 'api.nexiopaydev.com',
        certificateName: '*.nexiopaydev.com',
        appClientId: '1fng95dprkgs8hoe8al226v6ae',            // user-pools--> app clients --> cforce
        userPool: 'us-east-1_g4jnHb4HE',                      // user-pools--> General Settings --> cforce
        serviceUserPool: 'us-east-1_iU9rqeQmV',
        serviceAppClientId: '6tsakgncqfh5hap93r305hi7t4',
        iamRole: 'arn:aws:iam::720154970215:role/cforce-lambda-services',
        cloudfrontIamRole: 'arn:aws:iam::720154970215:role/cfn-cloudfront-lambda-execution',
        region: 'us-east-1',
        securityGroupId: 'sg-47b26d35',  //??
        stage: 'development',
        standardAuthorizer: 'arn:aws:lambda:us-east-1:720154970215:function:cforce-auth-development-standardAuthorizer',
        serviceBasicAuthorizer: 'arn:aws:lambda:us-east-1:720154970215:function:emvio-auth-development-authorizeService',
        subnetIdOne: 'subnet-5692017a',
        subnetIdTwo: 'subnet-45777479',
        subnetV2Id1: 'subnet-083b1c947265056d2',
        subnetV2Id2: 'subnet-083f3618715ea98de',
        subnetV2Id3: 'subnet-036e909ee8114e910',
        packageIndividually: false,
        dbUser: process.env.DB_USER || '',
        dbPassword: process.env.DB_PASSWORD || '',
        snsSendCforceEmailTopic: 'sendCforceEmailNotification-development',
        brokerAgreementExpressWebhook: 'broker-agreement-express-webhook-development'
    },
    staging: {
        domainName: 'api.nexiopaystaging.com',
        certificateName: '*.nexiopaystaging.com',
        appClientId: '7lokmloh30rsbc29omo4tjibk8',
        userPool: 'us-east-1_V5ns5bdMa',
        serviceUserPool: 'us-east-1_NGMnDoPtk',
        serviceAppClientId: '1pjcqr5434pfjodocagt3ou8ts',
        iamRole: 'arn:aws:iam::339414481913:role/cforce-lambda-services',
        cloudfrontIamRole: 'arn:aws:iam::339414481913:role/cfn-cloudfront-lambda-execution',
        region: 'us-east-1',
        securityGroupId: 'sg-0f8eca14cac7e4627',
        stage: 'staging',
        standardAuthorizer: 'arn:aws:lambda:us-east-1:339414481913:function:cforce-auth-staging-standardAuthorizer',
        serviceBasicAuthorizer: 'arn:aws:lambda:us-east-1:339414481913:function:emvio-auth-staging-authorizeService',
        subnetIdOne: 'subnet-fc213cd0',
        subnetIdTwo: 'subnet-9b27faa4',
        subnetV2Id1: 'subnet-016a3c200a04e8950',
        subnetV2Id2: 'subnet-0c56b4448f445d091',
        subnetV2Id3: 'subnet-0abe988d842e3db0d',
        packageIndividually: false,
        dbUser: process.env.DB_USER || '',
        dbPassword: process.env.DB_PASSWORD || '',
        snsSendCforceEmailTopic: 'sendCforceEmailNotification-staging',
        brokerAgreementExpressWebhook: 'broker-agreement-express-webhook-staging'
    },
    production: {
        domainName: 'api.cmsonline.com',
        certificateName: '*.cmsonline.com',
        appClientId: '7e2ec5jm0apikiadlq6g4cd2l5',
        userPool: 'us-east-1_CxrsSSmdt',
        serviceUserPool: 'us-east-1_Yrc408aUZ',
        serviceAppClientId: '7ql1smdirvqr6fcdrfcds2je9u',
        iamRole: 'arn:aws:iam::246295362269:role/cforce-lambda-services',
        cloudfrontIamRole: 'arn:aws:iam::246295362269:role/cfn-cloudfront-lambda-execution',
        region: 'us-east-1',
        securityGroupId: 'sg-e90e179b',
        stage: 'production',
        standardAuthorizer: 'arn:aws:lambda:us-east-1:246295362269:function:cforce-auth-production-standardAuthorizer',
        serviceBasicAuthorizer: 'arn:aws:lambda:us-east-1:246295362269:function:emvio-auth-production-authorizeService',
        subnetIdOne: 'subnet-a9c02dcd',
        subnetIdTwo: 'subnet-b54c4389',
        subnetV2Id1: 'subnet-0202bbb7315285f52',
        subnetV2Id2: 'subnet-00a51a21a9d361cd0',
        subnetV2Id3: 'subnet-037107d003d5fda99',
        packageIndividually: false,
        dbUser: process.env.DB_USER || '',
        dbPassword: process.env.DB_PASSWORD || '',
        snsSendCforceEmailTopic: 'sendCforceEmailNotification-production',
        brokerAgreementExpressWebhook: 'broker-agreement-express-webhook-production'
    },
    sandbox: {
        domainName: 'api.nexiopaysandbox.com',
        certificateName: '*.nexiopaysandbox.com',
        appClientId: '2isqo71nk0jtumglj2sm173ms3',
        userPool: 'us-east-1_85ww4iXXR',
        serviceUserPool: 'us-east-1_Fj03aymyU',
        serviceAppClientId: '7ivkjr2rb34vrefp8luchrja7',
        iamRole: 'arn:aws:iam::668734114184:role/emvio-lambda-services',
        cloudfrontIamRole: 'arn:aws:iam::668734114184:role/cfn-cloudfront-lambda-execution',
        region: 'us-east-1',
        securityGroupId: 'sg-0f27b0491fe74ad26',
        stage: 'sandbox',
        standardAuthorizer: 'arn:aws:lambda:us-east-1:668734114184:function:cforce-auth-sandbox-standardAuthorizer',
        serviceBasicAuthorizer: 'arn:aws:lambda:us-east-1:668734114184:function:emvio-auth-sandbox-authorizeService',
        subnetIdOne: 'subnet-0f57dc2954d1b6f0f',
        subnetIdTwo: 'subnet-03ecfdd7783545494',
        subnetV2Id1: 'subnet-03eeb8bae9310547a',
        subnetV2Id2: 'subnet-0561a463e80e3aa1b',
        subnetV2Id3: 'subnet-05294f6ba33b804af',
        packageIndividually: false,
        dbUser: process.env.DB_USER || '',
        dbPassword: process.env.DB_PASSWORD || '',
        snsSendCforceEmailTopic: 'sendCforceEmailNotification-production',
        brokerAgreementExpressWebhook: 'broker-agreement-express-webhook-sandbox'
    }
};
